import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react'

type ContextType = {
  isOpenPicker: boolean
  setIsOpenPicker: Dispatch<SetStateAction<boolean>>
}

const initContext = {
  isOpenPicker: false,
  setIsOpenPicker: () => null,
}

export const TokenPickerRevampContext = createContext<ContextType>(initContext)
const TokenPickerRevampProvider = ({ children }: HocProps) => {
  const [isOpenPicker, setIsOpenPicker] = useState(false)

  const value = useMemo(() => ({
    isOpenPicker,
    setIsOpenPicker,
  }), [isOpenPicker, setIsOpenPicker])

  return (
    <TokenPickerRevampContext.Provider value={value}>
      {children}
    </TokenPickerRevampContext.Provider>
  )
}

export default TokenPickerRevampProvider
